export default __webpack_public_path__ + "static/media/MATHEMATICS_ALGEBRA.f4307d1c.svg";